export const ANIMATION_DURATION = 1500;
export const EMOJI_COUNT = 16;
